module.exports = __webpack_public_path__ + "static/img/20161019-2.8dd6bcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20161019-2.jpg
// module id = vEwm
// module chunks = 0